{
  " - Charges": " - Charges",
  " - Produits": " - Produits",
  "__all__": "Erreur inattendue",
  "Account": "Compte",
  "Account disabled": "Compte bancaire désactivé",
  "Accounting firm": "Cabinet",
  "Accounting Firm": "Cabinet comptable",
  "Accounting firm not found": "Cabinet comptable introuvable",
  "Achats et fournitures": "Achats et fournitures",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Actif",
  "Add": "Ajouter",
  "Add cycle": "Ajouter Exercice",
  "Add keyword": "Ajouter un mot-clé",
  "Add new bank": "Ajouter une banque",
  "Add Vat": "Ajouter TVA",
  "Add ventilation": "Ajouter une ventilation",
  "All": "Tout",
  "Amount": "Montant TTC",
  "Amount range": "Plage de montants",
  "Amount to be distributed": "Montant manquant",
  "Amout": "Montant",
  "An error occurred, please refresh the page or click the button below": "Une erreur s'est produite, veuillez actualiser la page ou cliquer sur le bouton ci-dessous",
  "An unexpected error occurred processing your request, please try again later": "Une erreur inattendue s'est produite lors du traitement de votre demande, veuillez réessayer plus tard.",
  "Annotations": "Annotations",
  "Are you sure you want to delete this bulk?": "Êtes-vous sûr de vouloir supprimer ce lot?",
  "Are you sure you want to delete this delivery?": "Êtes-vous sûr de vouloir supprimer ce rémise?",
  "Are you sure you want to delete this transaction?": "Voulez-vous vraiment supprimer cette transaction\u00a0?",
  "Are you sure you want to move the bulk to Neoscan Expert?": "Êtes-vous sûr de vouloir déplacer le lot vers Neoscan Expert?",
  "Are you sure you want to move the bulk to SSI?": "Êtes-vous sûr de vouloir déplacer le lot vers SSI?",
  "Assign a category": "Affecter une catégorie",
  "Assign saved with success": "Attribution enregistrée avec succès",
  "ATC": "ATC",
  "Auto Liquidation": "Auto liquidation",
  "Back to list": "Retour à la liste",
  "Bank": "Banque",
  "Bank account": "Compte bancaire",
  "Bank accounts": "Comptes bancaires",
  "Bank description": "Description de la banque",
  "Banks": "Banques",
  "Banks account": "Compte bancaire",
  "Banks accounts": "Comptes bancaires",
  "Banks connections": "Connexions à la banque",
  "Book": "Journaux",
  "Book Bank": "Journal Banque",
  "Book cashed checks (Income)": "Journal: Chèques Encaissés (Recettes)",
  "Book issued checks (Expense)": "Journal: Chèques Emis (Dépenses)",
  "Bulk deleted with success": "Lot supprimé avec succès",
  "Bulks not validated": "Lot non validé",
  "Bulks validated": "Lot validé",
  "Cancel": "Annuler",
  "Categories": "Catégories",
  "Categories and Amount": "Catégories et montant",
  "categoriesAuto": "{{count}} catégorie a été paramétrée automatiquement",
  "categoriesAuto_one": "{{count}} catégorie a été paramétrée automatiquement",
  "categoriesAuto_many": "{{count}} catégorie a été paramétrée automatiquement",
  "categoriesAuto_other": "{{count}} catégorie a été paramétrée automatiquement",
  "categoriesAuto_plural": "{{count}} catégories ont été paramétrées automatiquement",
  "Categorized": "Catégorisé",
  "Category": "Catégorie",
  "Change": "Changer",
  "Change Bulk": "Changer lot",
  "Change Delivery": "Changement de rémise",
  "Charges": "Charges",
  "Charges de personnel": "Charges de personnel",
  "Charges Externes": "Charges Externes",
  "Click or drag file to this area to upload": "Cliquez ou déposez ici les justificatifs dans cette zone pour le télécharger",
  "Click or drag file to this area to upload!": "Cliquez ou faites glisser le fichier dans cette zone pour le télécharger\u00a0!",
  "Client support": "Support Client",
  "Close": "Fermer",
  "Code": "Code",
  "Code VAT": "Code TVA",
  "Collection sheet": "F. coll.",
  "company": "Entreprise",
  "Company": "Dossier",
  "Company not found": "Dossier introuvable",
  "Compte": "Compte",
  "Compte de Bilan ": "Compte de Bilan ",
  "Compte de Charge/Produit": "Compte de Charge/Produit",
  "Compte de resultat": "Compte de resultat",
  "Confirm": "Confirmer",
  "Confirm that you want to deactivate the connection?": "Confirmez-vous que vous souhaitez désactiver la connexion?",
  "Confirm the transactions to be submitted": "Veuillez confirmer les transactions à soumettre",
  "Connect to bank": "Connectez-vous à la banque",
  "Connection": "Connexion",
  "Connection bank": "Banque de connexion",
  "Connection Errors": "Connection Errors",
  "Connector Bank": "Banque de connecteurs",
  "Counterpart": "Imputation comptable",
  "Counterpart Bank": "Compte Banque",
  "Counterpart Buy": "Contrepartie de l’achat",
  "Counterpart cashed checks (Income)": "Compte: Chèques Encaissés (Recettes)",
  "Counterpart Immobilization": "Compte Immobilisation",
  "Counterpart issued checks (Expense)": "Compte: Chèques Emis (Dépenses)",
  "Counterpart Sell": "Contrepartie de la vente",
  "Couterparts by cycle": "Compte par exercice",
  "Create": "Créer",
  "Create bank cycle": "Créer un cycle de contrepartie",
  "Credit": "Entrées",
  "Currency": "Devise",
  "Custom": "Personnalisé",
  "Cycle": "Exercice",
  "Cycle date is not configured": "La date du cycle n'est pas configurée",
  "Cycle date is not valid": "La date du cycle n'est pas valide",
  "Cycle settings": "Paramètres du cycle",
  "Cycles": "Exercices",
  "Cycles to sync": "Exercices de synchronisation",
  "Date": "Date",
  "Date range": "Plage de dates",
  "Date/Time": "Date/Heure",
  "Debit": "Sorties",
  "Debit / Credit": "Entrées / Sorties",
  "Default book": "Journal par défaut",
  "Default counterpart": "Compte par défaut",
  "Default Vat": "TVA par défaut",
  "Default Vat Counterpart": "Contrepartie TVA par défaut",
  "Delete": "Supprimer",
  "Delete Bulk": "Supprimer lot",
  "Deliveries not validated": "Rémises non validées",
  "Deliveries validated": "Rémises validées",
  "Delivery deleted with success": "Rémise supprimée avec succès",
  "Desactive": "Désactivé",
  "Description": "Description",
  "Disable bank account": "Désactiver le compte bancaire",
  "Disconnect": "Déconnecter",
  "Divers": "Divers",
  "Do you want to delete this document?": "Voulez-vous supprimer ce document\u00a0?",
  "Document": "Piéce",
  "Documents": "Documents",
  "Dont TVA": "Dont TVA",
  "Edit": "Éditer",
  "Edit bank": "Éditer banque",
  "Edit bank account": "Modifier le compte bancaire",
  "Edit bank cycle": "Modifier exercice bancaire",
  "Edit Category": "Éditer catégorie",
  "Edit cycle settings": "Modifier les paramètres du cycle",
  "Edit vat": "Éditer TVA",
  "End": "Fin",
  "End connection with powens": "Terminer la connexion avec powens",
  "End date": "Date de fin",
  "English": "Anglais",
  "Error": "Erreur",
  "Expense": "Dépenses",
  "Expense Cash": "Depense en espèces",
  "Expense Claim": "Notes de frais",
  "Expense Claim Counterpart": "Notes de frais contrepartie",
  "Expense In Cash Counterpart": "Depense en espèces contrepartie",
  "Fiche": "Fiche",
  "Filters": "Filtres",
  "French": "Français",
  "FULL": "T.Ext.",
  "FULL_display": "T.Ext. - Tenue extarnalisée",
  "Go to Account": "Accéder au compte",
  "Go to Home": "Aller à la maison",
  "Go to settings": "Accéder aux paramètres",
  "Group": "Groupe",
  "HALF": "N.Dig.",
  "HALF_display": "N.Dig. - Newrai digital",
  "HelpDesk": "Support client",
  "Iban": "IBAN",
  "Id": "Id",
  "Image must be smaller than 2MB!": "L'image doit être inférieure à 2\u00a0Mo\u00a0!",
  "Impots": "Impots",
  "Inactive": "Inactif",
  "Income BankAccount": "Recette sur compte bancaire",
  "Income Cash": "Revenu en especes",
  "Income In Cash Counterpart": "Revenu en especes contrepartie",
  "Income In Personal Bank Account Counterpart": "Recette sur compte bancaire personel contrepartie",
  "Is connected": "Est connecté",
  "Is imobilization": "Est-ce que l'immobilisation",
  "It is necessary to configure the bank accounts with the accounting data for the date of this transaction. After this configuration you will be able to classify your transactions.": "Il est nécessaire de configurer les comptes bancaires avec les données comptables à la date de cette transaction. Après cette configuration vous pourrez classer vos transactions.",
  "It is not possible to send more than 1 document!": "Il n'est pas possible d'envoyer plus de 1 document",
  "It is not possible to send more than 8 documents!": "Il n'est pas possible d'envoyer plus de 8 documents",
  "Keyword": "Mot-clé",
  "Keywords": "Mots clés",
  "Label": "Libellé",
  "Last month": "Le mois dernier",
  "Last semester": "Le semestre dernier",
  "Last Transactions Sync": "Synchronisation des dernières transactions",
  "Last Update": "Dernière mise à jour",
  "Last week": "La semaine dernière",
  "Last year": "L'année dernière",
  "List transaction": "Liste des transactions",
  "Load more": "Charger plus",
  "Loading": "Chargement",
  "Loading...": "Chargement...",
  "Login": "Login",
  "Logout": "Déconnexion",
  "Main Bank": "Banque Principale",
  "Manage in Powens": "Gérer sur Powens",
  "Manage powens connections": "Gérer les connexions de powens",
  "Max": "Max",
  "Min": "Min",
  "Missing amount": "Montant manquant",
  "Missing category": "Catégorie manquante",
  "Missing Dont TVA": "Dont TVA manquante",
  "Missing TVA": "TVA manquante",
  "Montant TTC": "Montant TTC",
  "Name": "Nom",
  "New": "Nouveau",
  "Newrai support": "Support Newrai",
  "No": "Non",
  "No active cycle is configured for this bank account. A new cycle must be created.": "Aucun cycle actif n’est configuré pour ce compte bancaire. Veuillez créer un nouveau cycle.",
  "No options": "Aucune option",
  "No Options": "Aucune option",
  "No transactions": "Sans transactions",
  "NONE": "T.Cab.",
  "NONE_display": "T.Cab. - Tenue cabinet",
  "Not Started": "Pas commencé",
  "Not validated": "Non validé",
  "on": "le",
  "Oops Page Not Found": "Oops Page non trouvée",
  "Operating result": "Résultat d'exploitation",
  "Operation type": "Type d'opération",
  "Operation Type": "Type d'opération",
  "Operations": "Opérations",
  "OPS": "OPS",
  "Order by": "Commandé par",
  "Page Not Found": "Page non trouvée",
  "Par catégorie": "Par catégorie",
  "Par compte": "Par compte",
  "Par type d'opération": "Par type d'opération",
  "Period": "Période",
  "Pilotage": "Pilotage",
  "Please contact support.": "Veuillez contacter l'assistance.",
  "Please input Counterpart Immobilization": "Veuillez entrer Compte Immobilisation",
  "Please select a company to view company data": "Veuillez sélectionner une entreprise pour afficher les données de l'entreprise.",
  "Please select the words you want to assign to a category in the box below.": "Veuillez sélectionner les mots que vous souhaitez attribuer à une catégorie dans la case ci-dessous.",
  "previous month": "Mois précédent",
  "Previous semester": "Semestre précédent",
  "Produits": "Produits",
  "Purchase allocation": "Allocation d’achat",
  "Rate": "Taux",
  "Recipes": "Revenus",
  "Reconnect": "Se reconnecter",
  "Reference": "Référence",
  "Refresh page": "Rafraîchir la page",
  "Regime": "Régime",
  "Registered": "Enregistré",
  "Required action": "Action requise",
  "Reset": "Réinitialiser",
  "Reset filters": "Réinitialiser filtres",
  "Retransfer of a bulk to SSI": "Retransfer d'un lot vers SSI",
  "Roll Back made with success": "Roll back fait avec succès",
  "Sales allocation": "Répartition des ventes",
  "Save": "Enregistrer",
  "Save success": "Enregistré avec succès",
  "Save Success": "Enregistré avec succès",
  "Search": "Rechercher",
  "Section": "Section",
  "Select": "Sélectionner",
  "Select all categorized transactions": "Sélectionner toutes les transactions catégorisées",
  "Select book": "Sélectionnez un journal",
  "Select book bank": "Sélectionnez type de journaux banque",
  "Select Category": "Choisir une catégorie",
  "Select company": "Sélectionner une entreprise",
  "Select Company": "Sélectionnez une entreprise",
  "Select connector bank": "Sélectionnez la banque de connecteurs",
  "Select counterpart": "Sélectionnez une Compte",
  "Select counterpart bank": "Sélectionner contrepartie banque",
  "Select cycle": "Sélectionner exercise",
  "Select Text": "Mots sélectionnés",
  "Selected_one": "{{count}} sélectionné",
  "Selected_many": "{{count}} sélectionné",
  "Selected_other": "{{count}} sélectionné",
  "Selected Words": "Mots sélectionnés",
  "Send back to neoscan expert": "Renvoyer à neoscan expert",
  "Send back to SSI": "Renvoyer à SSI",
  "SEPA Credential Identifier": "Identifiant Créancier SEPA",
  "Setting up bank accounts": "Création de comptes bancaires",
  "Settings": "Paramètres",
  "Some banks will be removed because they are duplicates": "Certains comptes bancaires seront supprimées car ce sont des doublons.",
  "Start": "Début",
  "Start date": "Date de début",
  "status": "statut",
  "Status": "Statut",
  "Submit": "Soumettre",
  "Submit here the supporting documents that you wish to attach to this transaction": "Déposez ici les justificatifs que vous souhaitez attacher à cette transaction",
  "Submited by": "Envoyée par",
  "Submitted": "Soumise",
  "submitTransactions_zero": "Valider les transactions",
  "submitTransactions_one": "Valider le {{count}} transaction",
  "submitTransactions_other": "Valider les {{count}} transactions",
  "Suggestion": "Suggestion",
  "SURVEILLANCE": "Surv.",
  "SURVEILLANCE_display": "Surv. - Surveillance",
  "Sync": "Synchroniser",
  "Sync Accounts": "Synchroniser les comptes",
  "Sync Connections": "Synchroniser les connexions",
  "Sync Transactions": "Synchroniser les transactions",
  "Terminate connection": "Terminer la connexion",
  "Thank you": "Merci",
  "The connection is not synchronized": "La connexion n'est pas synchronisée",
  "The counterpart has been successfully added to the category": "La contrepartie a été ajoutée avec succès à la catégorie",
  "The counterpart related to the transaction type is not setting up correctly": "La contrepartie liée au type de transaction ne se configure pas correctement",
  "The current cycle": "L’exercice en cours",
  "The inserted date is not valid or the cycle doesn't exist": "La date insérée n'est pas valide ou le cycle n'existe pas",
  "The keyword has been successfully added to the category": "Le mot-clé a été modifié avec succès dans la catégorie.",
  "The page you are looking for does not exist or has been moved": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "The transaction has been successfully deleted": "La transaction a bien été supprimée",
  "There are no transactions": "Il n'y a pas de transactions",
  "There are no transactions categorized to be validated": "Il n’y a pas de transactions catégorisées à valider",
  "There are transactions outside the activity cycle.": "Il existe des transactions en dehors du cycle d'activité.",
  "There is no connection": "Il n'y a pas de connexion",
  "These transactions cannot be classified, this information this in the corresponding transactions.": "Ces opérations ne peuvent être classées, cette information se trouve dans les opérations correspondantes.",
  "This accounting firm does not exist or you do not have access to it.": "Ce cabinet comptable n'existe pas ou vous n'y avez pas accès.",
  "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?": "Cette action désactivera le compte bancaire et toutes les transactions associées. Êtes-vous sûr de vouloir désactiver ce compte bancaire ?",
  "This company does not exist or you do not have access to it.": "Ce dossier n'existe pas ou vous n'y avez pas accès.",
  "This category is not parameterized, go to the categories menu and configure it.": "Cette catégorie n'est pas paramétrée, veuillez configurer celle-ci dans le menu catégories.",
  "This field is required": "Ce champ est requis",
  "This transaction cannot be classified because it is not associated with a banking exercise.": "Cette opération ne peut être classée car elle n’est pas associée à un exercice bancaire.",
  "This transaction cannot be classified because it is not associated with a fiscal year or a banking year.": "Cette transaction ne peut être classée car elle n'est pas associée à un exercice ou à un exercice bancaire.",
  "To categorize": "À catégoriser",
  "To define": "À définir",
  "Total": "Total",
  "Total Balance": "Solde Total",
  "Total pages": "Pages totales",
  "Total table items_one": "Éléments au total",
  "Total table items_many": "Éléments au total",
  "Total table items_other": "Éléments au total",
  "Transaction": "Transaction",
  "transactions": "Transactions",
  "Transactions": "Transactions",
  "Transactions exceed the current cycle. A new cycle is required.": "Les transactions dépassent le cycle en cours. Nouveau cycle requis.",
  "Transactions imported successfully": "Transactions importées avec succès",
  "Transactions were successfully submitteds": "Les transactions ont été soumises avec succès",
  "Transations": "Transactions",
  "TVA": "TVA",
  "Types of transactions": "Types de transaction",
  "Unexpected error": "Erreur inattendue",
  "unsuccess": "Le montant n'a pas été entièrement distribué, {{amount}} restent à allouer.",
  "Updated": "Mis à jour",
  "Validate transactions": "Valider les transactions",
  "Validate transactions ": "Valider les transactions",
  "Validate transactions_plural": "Valider les {{count}} transactions",
  "Validated": "Catégorisées",
  "Value is not valid": "La valeur n'est pas valide",
  "Vat": "TVA",
  "Vat NewRAi": "TVA NewRAi",
  "VAT to be defined": "TVA à définir",
  "Vats": "TVA",
  "Ventilation": "Ventilation",
  "Ventilations": "Ventilation",
  "With": "Avec",
  "Without": "Sans",
  "Yes": "Oui",
  "You are logged out": "Vous êtes déconnecté",
  "You can only upload JPG/PNG/PDF file!": "Vous ne pouvez télécharger que des fichiers JPG/PNG/PDF\u00a0!",
  "You must fill in at least one Ventilation": "Vous devez renseigner au moins une Ventilation"
}
